module.exports = __webpack_public_path__ + "static/media/pairRed.00981fb4.svg";